import FileDelete from './FileDelete'
export {FileDelete}
export default FileDelete
